import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Legal_Entity_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
} from "../../../../../../../features/admin/quality_management/structural_requirement/legal_entity/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Legal_Entity_Form({ handleClose }) {
  const [success, setSuccess] = useState(false);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("legal_entity", data.legal_entity);
      sendData.append("date_of_establishment", data.date_of_establishment);
      sendData.append("other_accereditation", data.other_accereditation || "");

      sendData.append(
        "companies_act_certificate",
        data.companies_act_certificate[0],
      );

      sendData.append("attach_file", data.attach_file[0]);

      const res = await dispatch(Create(sendData));

      if (res.meta.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());
        reset();

        setCompaniesPreview(null);
        setAttachPreview(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ⏱ auto hide success toaster
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Legal Entity Name"
                    {...register("name", {
                      required: "Legal Entity Name is required",
                    })}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Type</Form.Label>

                  <Form.Control
                    placeholder="Enter Legal Entity Type"
                    {...register("legal_entity", {
                      required: "Legal Entity Type is required",
                    })}
                  />
                  {errors.legal_entity && (
                    <small className="text-danger">
                      {errors.legal_entity.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="form_group">
                  <Form.Label>Date of Establishment</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Select Date of Establishment"
                    {...register("date_of_establishment", {
                      required: "Date of Establishment is required",
                      // validate: (value) => {
                      //   const year = value.split("-")[0];

                      //   if (year.length !== 4) {
                      //     return "Year must be exactly 4 digits";
                      //   }

                      //   const selectedDate = new Date(value);
                      //   const today = new Date();
                      //   today.setHours(0, 0, 0, 0);

                      //   if (selectedDate < today) {
                      //     return "Past dates are not allowed";
                      //   }

                      //   return true;
                      // },
                    })}
                    onChange={(e) => {
                      let value = e.target.value;
                      const parts = value.split("-");

                      if (parts[0] && parts[0].length > 4) {
                        parts[0] = parts[0].slice(0, 4);
                        e.target.value = parts.join("-");
                      }
                    }}
                  />
                  {errors.date_of_establishment && (
                    <small className="text-danger">
                      {errors.date_of_establishment.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              {/* 🔹 Companies Act Certificate */}
              <div className="col-md-4">
                <Form.Group className="form_group file_field">
                  <Form.Label>Companies Act Certificate</Form.Label>

                  <div className="absolute_fields">
                    <Form.Control
                      type="file"
                      {...register("companies_act_certificate", {
                        required:
                          typeof getValues("companies_act_certificate") ===
                          "string"
                            ? false
                            : "File is required",
                      })}
                      accept="*"
                    />
                    <div className="upload_icon_holder">
                      <FontAwesomeIcon
                        icon={faUpload}
                        className="upload_icon"
                      />
                    </div>
                  </div>

                  {errors.companies_act_certificate && (
                    <small className="text-danger">
                      {errors.companies_act_certificate.message}
                    </small>
                  )}

                  {(() => {
                    const fileValue = watch("companies_act_certificate");

                    // URL for preview
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Service</Form.Label>
                  {/* <Form.Label>Other Accreditations</Form.Label> */}
                  <Form.Control
                    placeholder="Enter Type Of Service"
                    {...register("other_accereditation", {
                      required: "Type Of Service is required",
                    })}
                  />
                  {errors.other_accereditation && (
                    <small className="text-danger">
                      {errors.other_accereditation.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              {/* 🔹 Attach File */}
              <div className="col-md-4">
                <Form.Group className="form_group file_field">
                  <Form.Label>
                    Attached File <sub>(i.e pancard/ adhar card)</sub>
                  </Form.Label>

                  <div className="absolute_fields">
                    <Form.Control
                      type="file"
                      {...register("attach_file", {
                        required:
                          typeof getValues("attach_file") === "string"
                            ? false
                            : "File is required",
                      })}
                      accept="*"
                    />
                    <div className="upload_icon_holder">
                      <FontAwesomeIcon
                        icon={faUpload}
                        className="upload_icon"
                      />
                    </div>
                  </div>

                  {errors.attach_file && (
                    <small className="text-danger">
                      {errors.attach_file.message}
                    </small>
                  )}

                  {(() => {
                    const fileValue = watch("attach_file");

                    // URL for preview
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </Form.Group>
              </div>
            </div>

            <div className="permission_btn_holder">
              {success ? (
                <Success_Toster successText="data Save Successfully!" />
              ) : (
                <>
                  <Button
                    type="button"
                    className="permission_btn No_btn"
                    onClick={() => reset()}
                  >
                    Reset
                  </Button>

                  <Button type="submit" className="permission_btn Yes_btn">
                    Save
                  </Button>
                </>
              )}
            </div>
          </Form>
        </div>
      </section>
    </>
  );
}

export default Legal_Entity_Form;
